import { render, staticRenderFns } from "./Sunset.vue?vue&type=template&id=7bde7a78&scoped=true&lang=pug"
import script from "./Sunset.vue?vue&type=script&lang=js"
export * from "./Sunset.vue?vue&type=script&lang=js"
import style0 from "./Sunset.vue?vue&type=style&index=0&id=7bde7a78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde7a78",
  null
  
)

export default component.exports